import axios from "axios";
import { encryptData, decryptData } from "../helpers/crypto";

const axiosInstance = axios.create({
  baseURL: "https://api.king999.co/api/v1",
  // baseURL: "http://192.168.1.17:5000/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // ✅ FormData (file uploads) ke liye encryption SKIP karo
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
    return config;
  }

  // Normal JSON requests ke liye encryption
  if (config.data) {
    config.data = {
      payload: encryptData(config.data),
    };
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data.payload) {
      response.data = decryptData(response.data.payload);
    }

    return response;
  },
  (error) => {
    // ✅ Token Expire / Unauthorized check
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.clear();
      // window.location ka use isliye kiya kyunki axios file React ke bahar hai
      if (window.location.pathname !== "/login") {
        window.location.href = "/login"; 
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;